import { Image } from 'react-bootstrap';

export const StrokeDivider = ({ src, flipped = false }) => (
    <div className="stroke-divider">
        <Image src={src} className={`stroke${flipped ? ' flipped' : ''}`} />
    </div>
);
